import { Text, vars } from "@vericus/cadmus-ui";

import clsx from "clsx";

import squigglyNoteIcon from "@/assets/illustrations/squiggly-note.svg";
import feedbackImg from "@/assets/illustrations/students-discussing.png";
import { FeedbackLevel } from "@/generated/graphql";

import * as styles from "./feedback-results.css";

interface Props {
  feedbackViewLevel: FeedbackLevel;
  finalGrade?: number | null;
  maxGrade: number;
}

export function FeedbackResults({
  maxGrade,
  feedbackViewLevel,
  finalGrade,
}: Props) {
  const showMarks = feedbackViewLevel !== FeedbackLevel.Feedback;
  const getScore = (score?: number | null) => {
    if (score === null || score === undefined) return "-";

    return score.toFixed(2);
  };

  return (
    <div className={clsx(styles.feedbackOverviewResults, styles.feedbackLeft)}>
      <Text kind="displayThree" style={{ fontSize: "2rem" }}>
        <span style={{ color: vars.colors.lilac500 }}>Feedback</span> has been
        released
      </Text>
      <div className={styles.feedbackResults}>
        <img src={feedbackImg} height={140} width={140} alt="" />
        <div className={clsx(styles.gradeContent, styles.gradeResults)}>
          <img src={squigglyNoteIcon} width={39} height={32} alt="" />
          <div>
            <Text kind="headingFour">
              {showMarks ? getScore(finalGrade) : "xx.xx"}/{maxGrade}
            </Text>
            <Text kind="label" bold>
              Final grade
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
